// NEKASSUR — Articles "Conseils" (bilingue). Contenu administrable localement.
// Pour ajouter un article : dupliquer un objet. published:false => masqué en production.
// Les offres partenaires doivent afficher durée + conditions.

export const articleCategories = ["particuliers", "professionnels", "complexes", "epargne", "frontaliers", "actualites"];

export const articles = [
  {
    slug: "malus-resiliation-que-faire",
    category: "complexes",
    published: true,
    date: "2026-05-12",
    author: "Yanis Nekhla",
    readingTime: 4,
    image: "https://images.unsplash.com/photo-1611448746128-7c39e03b71e4",
    fr: {
      title: "Malus, résiliation : que faire quand personne ne veut vous assurer ?",
      excerpt: "Un refus n'est pas une fin de parcours. Voici comment un dossier bien présenté change souvent la donne.",
      body: [
        "Un malus élevé ou une résiliation pour sinistres peut donner l'impression qu'aucune assurance n'est possible. C'est rarement vrai. Le problème vient plus souvent d'un dossier mal présenté que du profil lui-même.",
        "La première étape consiste à comprendre le passif : nombre et nature des sinistres, motif de résiliation, relevé d'information. Ces éléments, présentés clairement, permettent d'orienter le dossier vers les bons partenaires.",
        "Certains assureurs et courtiers grossistes acceptent précisément les profils que d'autres refusent en direct. Encore faut-il savoir à qui s'adresser et comment argumenter votre situation.",
        "Chez NEKASSUR, nous ne garantissons jamais l'acceptation, mais nous nous engageons à étudier réellement votre dossier et à solliciter les partenaires adaptés. C'est souvent ce qui fait la différence.",
      ],
    },
    en: {
      title: "Penalty, cancellation: what to do when no one wants to insure you?",
      excerpt: "A refusal is not the end of the road. Here's how a well-presented case often changes things.",
      body: [
        "A high penalty or a cancellation for claims can give the impression that no insurance is possible. This is rarely true. The problem more often comes from a poorly presented case than from the profile itself.",
        "The first step is to understand the history: number and nature of claims, reason for cancellation, insurance record. Presented clearly, these elements help direct the case to the right partners.",
        "Some insurers and wholesale brokers specifically accept the profiles that others refuse directly. You just need to know who to approach and how to argue your situation.",
        "At NEKASSUR, we never guarantee acceptance, but we commit to genuinely studying your case and reaching out to suitable partners. That is often what makes the difference.",
      ],
    },
  },
  {
    slug: "changer-assurance-emprunteur",
    category: "particuliers",
    published: true,
    date: "2026-05-03",
    author: "Yanis Nekhla",
    readingTime: 3,
    image: "https://images.pexels.com/photos/7821486/pexels-photo-7821486.jpeg",
    fr: {
      title: "Assurance de prêt : votre droit de changer, expliqué simplement",
      excerpt: "Changer l'assurance de votre crédit peut représenter une économie réelle. Voici l'essentiel.",
      body: [
        "La réglementation vous permet de substituer l'assurance de votre prêt immobilier, sous réserve d'un niveau de garanties au moins équivalent à celui exigé par votre banque.",
        "L'enjeu est double : le coût, mais aussi l'adéquation des garanties à votre profil, notamment en cas de risque de santé ou de profession particulière.",
        "Un courtier vous aide à comparer les garanties, à constituer un dossier solide et à respecter le formalisme de substitution auprès de la banque.",
        "N'hésitez pas à faire étudier votre contrat actuel : l'écart peut être significatif sur la durée du crédit.",
      ],
    },
    en: {
      title: "Loan insurance: your right to switch, explained simply",
      excerpt: "Switching your loan insurance can mean real savings. Here's the essential.",
      body: [
        "Regulations allow you to substitute your property loan insurance, provided the cover is at least equivalent to that required by your bank.",
        "There are two stakes: cost, but also how well the cover fits your profile, especially in case of a health risk or a specific profession.",
        "A broker helps you compare cover, build a solid case and follow the substitution formalities with the bank.",
        "Don't hesitate to have your current contract reviewed: the difference can be significant over the life of the loan.",
      ],
    },
  },
  {
    slug: "decennale-creation-entreprise",
    category: "professionnels",
    published: true,
    date: "2026-04-28",
    author: "Yanis Nekhla",
    readingTime: 4,
    image: "https://images.pexels.com/photos/1216589/pexels-photo-1216589.jpeg",
    fr: {
      title: "Décennale en création d'entreprise : par où commencer ?",
      excerpt: "Se lancer dans le BTP implique une obligation d'assurance. Voici comment aborder sereinement votre décennale.",
      body: [
        "La responsabilité civile décennale est obligatoire pour la plupart des métiers du bâtiment. Elle couvre, pendant dix ans après réception, les dommages compromettant la solidité de l'ouvrage.",
        "En création d'entreprise, l'obtention dépend beaucoup de la clarté de votre dossier : activités précises, qualifications, expérience et prévisionnel.",
        "Mieux vaut présenter chaque corps de métier exercé, sans en omettre : une déclaration incomplète peut fragiliser votre couverture.",
        "Nous vous aidons à structurer votre demande et à la présenter aux partenaires adaptés aux entreprises récentes.",
      ],
    },
    en: {
      title: "Decennial cover for a start-up: where to begin?",
      excerpt: "Starting in construction implies an insurance obligation. Here's how to approach your decennial cover calmly.",
      body: [
        "Decennial liability is mandatory for most construction trades. It covers, for ten years after handover, damage affecting the structural soundness of the work.",
        "For a start-up, obtaining cover depends heavily on the clarity of your case: precise activities, qualifications, experience and projections.",
        "It's best to declare every trade you practise, without omission: an incomplete declaration can weaken your cover.",
        "We help you structure your request and present it to partners suited to recent companies.",
      ],
    },
  },
  {
    slug: "assurance-vie-per-difference",
    category: "epargne",
    published: true,
    date: "2026-04-20",
    author: "Yanis Nekhla",
    readingTime: 5,
    image: "https://images.pexels.com/photos/3943716/pexels-photo-3943716.jpeg",
    fr: {
      title: "Assurance-vie ou PER : comment choisir selon vos objectifs ?",
      excerpt: "Deux enveloppes complémentaires, des logiques différentes. Le point pour y voir clair.",
      body: [
        "L'assurance-vie est une enveloppe souple, adaptée à l'épargne disponible et à la transmission. Le PER est davantage tourné vers la préparation de la retraite.",
        "Le choix dépend de votre horizon, de votre besoin de disponibilité et de votre situation. Les deux peuvent d'ailleurs se compléter.",
        "Attention : selon les supports choisis, un risque de perte en capital peut exister. Aucun rendement n'est garanti et les avantages fiscaux dépendent de votre situation.",
        "Un accompagnement permet d'arbitrer sereinement entre sécurité, performance et objectifs de vie.",
      ],
    },
    en: {
      title: "Life insurance or PER: how to choose based on your goals?",
      excerpt: "Two complementary envelopes, different logics. Here's how to see clearly.",
      body: [
        "Life insurance is a flexible envelope, suited to available savings and transmission. The PER is more geared towards retirement preparation.",
        "The choice depends on your horizon, need for availability and situation. In fact, the two can complement each other.",
        "Note: depending on the supports chosen, a risk of capital loss may exist. No return is guaranteed and tax benefits depend on your situation.",
        "Guidance helps you calmly balance security, performance and life goals.",
      ],
    },
  },
  {
    slug: "frontalier-suisse-assurances",
    category: "frontaliers",
    published: true,
    date: "2026-04-15",
    author: "Yanis Nekhla",
    readingTime: 4,
    image: "https://images.unsplash.com/photo-1517048676732-d65bc937f952",
    fr: {
      title: "Frontalier en Suisse : les points d'attention côté assurances",
      excerpt: "Résider en France et travailler en Suisse implique des choix spécifiques. Un tour d'horizon.",
      body: [
        "En tant que résident français travaillant en Suisse, votre situation d'assurance mérite un examen attentif : santé, prévoyance, épargne et transmission.",
        "Certaines solutions d'épargne et d'assurance-vie sont éligibles à votre résidence fiscale française et peuvent s'intégrer à une stratégie cohérente.",
        "NEKASSUR intervient ici en expertise complémentaire, pour les personnes résidant en France. Nous ne sommes pas un cabinet suisse.",
        "L'objectif : clarifier vos options et rechercher des solutions adaptées à votre statut particulier.",
      ],
    },
    en: {
      title: "Cross-border worker in Switzerland: insurance points to watch",
      excerpt: "Living in France and working in Switzerland involves specific choices. An overview.",
      body: [
        "As a French resident working in Switzerland, your insurance situation deserves careful review: health, protection, savings and transmission.",
        "Some savings and life-insurance solutions are eligible for your French tax residence and can fit into a coherent strategy.",
        "NEKASSUR acts here as complementary expertise, for people residing in France. We are not a Swiss firm.",
        "The goal: clarify your options and search for solutions suited to your particular status.",
      ],
    },
  },
  {
    slug: "offre-partenaire-printemps",
    category: "actualites",
    published: true,
    date: "2026-05-20",
    author: "NEKASSUR",
    readingTime: 2,
    image: "https://images.pexels.com/photos/5668858/pexels-photo-5668858.jpeg",
    isOffer: true,
    offer: { fr: "Offre valable jusqu'au 30 juin 2026, sous conditions.", en: "Offer valid until 30 June 2026, subject to conditions." },
    fr: {
      title: "Actualité : évolutions utiles chez nos partenaires ce printemps",
      excerpt: "Certains partenaires font évoluer leurs offres. Nous relayons uniquement des informations vérifiées.",
      body: [
        "Ce printemps, plusieurs partenaires font évoluer leurs conditions sur des produits particuliers et professionnels.",
        "Nous ne relayons que des informations que nous pouvons vérifier, et toute offre ponctuelle s'accompagne de sa durée et de ses conditions principales.",
        "Pour savoir si une évolution est pertinente pour votre situation, le plus simple reste d'en discuter avec nous.",
      ],
    },
    en: {
      title: "News: useful changes at our partners this spring",
      excerpt: "Some partners are updating their offers. We only relay verified information.",
      body: [
        "This spring, several partners are updating their conditions on individual and professional products.",
        "We only relay information we can verify, and any time-limited offer comes with its duration and main conditions.",
        "To find out whether a change is relevant to your situation, the simplest is to discuss it with us.",
      ],
    },
  },
];

export const getArticleBySlug = (slug) => articles.find((a) => a.slug === slug);
export const publishedArticles = () => articles.filter((a) => a.published);
